// @ts-nocheck

import { createSelector } from 'reselect';

import { Target } from '../../client';
import { __, getLang } from '../../i18n/l10n';
import { getItemIdFromProps } from '../../selectors/_propsGetters_';
import {
  selectBasketError,
  selectBasketIsCashout,
  selectBasketIsFromFreebets,
  selectBasketMode,
} from '../../selectors/basket/basketPrimary.selector';
import {
  selectBasketShowResume,
  selectBasketIsInputDisabled,
  makeBasketItemIdSelector,
  makeBasketItemIsValidatedSelector,
  makeBasketActiveStakeSelector,
  makeBasketIsFreebetSelector,
} from '../../selectors/basketCommon.selector';
import { selectBasketEnhancedItems } from '../../selectors/basketItems.selector';
import { BasketModes } from '../../types/basket';
import { Locales } from '../../types/common';
import { basket as BasketUtils } from '../../utils';

const makeBasketStakePropsSelector = () => {
  const getActiveErrorCode = createSelector([selectBasketError, makeBasketItemIdSelector()], (basketError, item) => {
    let ecode = basketError?.ecode;
    if (item) {
      ecode = item.error?.ecode;
    }
    return ecode;
  });

  const getIsVisible = createSelector(
    [selectBasketMode, selectBasketEnhancedItems, selectBasketShowResume, getItemIdFromProps],
    (mode, items, showResume, itemIdModeSimple) => {
      const isModeSimple = mode === BasketModes.SIMPLE;
      const isMultipleSimpleBets = isModeSimple && items.length > 1;
      const isOneSimpleBet = isModeSimple && items.length === 1;
      return (
        (isOneSimpleBet && !itemIdModeSimple) ||
        (!isModeSimple && !itemIdModeSimple) ||
        (isMultipleSimpleBets && itemIdModeSimple)
      );
    },
  );

  const getIsReadOnly = createSelector(
    [selectBasketIsCashout, selectBasketShowResume, makeBasketItemIsValidatedSelector()],
    (isCashout, showResume, isItemIsValidated) => {
      return showResume || isCashout || isItemIsValidated;
    },
  );

  return createSelector(
    [
      selectBasketMode,
      selectBasketEnhancedItems,
      selectBasketIsInputDisabled,
      getIsReadOnly,
      makeBasketItemIdSelector(),
      getIsVisible,
      makeBasketActiveStakeSelector(),
      getActiveErrorCode,
      makeBasketIsFreebetSelector(),
      selectBasketIsFromFreebets,
    ],
    (mode, items, isDisabled, isReadOnly, itemId, isVisible, stake, ecode, isFreebet, isFromFreebets) => {
      const isModeSimple = mode === BasketModes.SIMPLE;
      const isMultipleSimpleBets = isModeSimple && items.length > 1;

      const leftSymbol = getLang() === Locales.EN;
      const placeholderLabel = isFreebet || isFromFreebets ? __('Freebets Wager') : __('Wager');
      const hasError = BasketUtils.hasErrorRelativeToStake(ecode);
      const shouldOpenKeyboardModal = Target.__MOBILE__ && isVisible && isMultipleSimpleBets;
      const isInSummary = (isModeSimple && items.length === 1) || !itemId;

      return {
        isVisible,
        isFreebet,
        stake,
        itemId,
        leftSymbol,
        hasError,
        placeholderLabel,
        isReadOnly,
        shouldOpenKeyboardModal,
        isDisabled,
        isInSummary,
        isFromFreebets,
      };
    },
  );
};

export default makeBasketStakePropsSelector;
